export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/self_help_wellness.9480488.svg";